import Vue from 'vue'
import App from './Index.vue'
import '../common.js'

new Vue({
    render: h => h(App)
}).$mount('#app');

